/**
 * Error class for content API clients (SCORM, TinCan, etc.)
 */
export class ContentClientError extends Error {
  constructor(
    message: string,
    public details?: unknown
  ) {
    super(message);
    this.name = 'ContentClientError';
    this.details = details;
  }
}
